import axios from 'axios';
import { Tag, TagSearchFilterParam, TagsParams } from '../interfaces/api/tag';

function queryBuilderSearchFilter(params: TagSearchFilterParam): URLSearchParams {
	const queryParams = new URLSearchParams();
	if (params.search) {
		queryParams.append('search', params.search);
	}
	if (params.device) {
		queryParams.append('device', params.device);
	}
	if (params.device__controller) {
		queryParams.append('device__controller', params.device__controller);
	}
	if (params.modality) {
		queryParams.append('modality', params.modality);
	}
	if (params.device__organization) {
		queryParams.append('device__organization', params.device__organization);
	}
	if (params.device__building) {
		queryParams.append('device__building', params.device__building);
	}
	if (params.device__floor) {
		queryParams.append('device__floor', params.device__floor);
	}
	if (params.device__room) {
		queryParams.append('device__room', params.device__room);
	}
	return queryParams;
}

export async function getTags(): Promise<Tag[]> {
	try {
		const response = await axios.get<Tag[]>('api/tags/');
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getTag(id: number): Promise<Tag> {
	try {
		const response = await axios.get<Tag>(`api/tags/${id}/`);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function getTagsSearchFilter(params: TagSearchFilterParam): Promise<Tag[]> {
	try {
		const queryParams = queryBuilderSearchFilter(params);
		const response = await axios.get<Tag[]>(`api/tags/`, {
			params: queryParams,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}

export async function patchTag(id: number, params: TagsParams): Promise<Tag> {
	try {
		const response = await axios.patch<Tag>(`api/tags/${id}/`, params);
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response;
		}
		throw error;
	}
}
